import React from "react";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import classNames from "classnames";

import { PATHS } from "@router/paths";

import Navbar from "@components/layoutElements/Navbar/Navbar";
import MobileToolbar from "@components/layoutElements/MobileToolbar/MobileToolbar";
import MainSidebar from "@components/layoutElements/MainSidebar/MainSidebar";
import Button from "@components/dataEntry/buttons/Button/Button";
import ChevronLeft from "@components/assets/ChevronLeft";

import "./MainLayout.scss";

interface LayoutProps {
  children: React.ReactNode;
  withGoBack?: boolean;
  className?: string;
}

const MainLayout = ({ children, withGoBack = false, className }: LayoutProps) => {
  const navigate = useNavigate();
  const { t } = useTranslation("common");
  const classes = classNames("main-layout", className);

  const goBack = () => {
    if (window.history.length > 1) {
      navigate(-1);
    } else {
      navigate(PATHS.main.path);
    }
  };

  return (
    <div className={classes}>
      <header className="header-part">
        <Navbar />
      </header>

      <div className="sidebar-part">
        <MainSidebar />
      </div>

      <main className="main-part">
        {withGoBack && (
          <div className="back-button">
            <Button variant="tertiary" onClick={goBack}>
              <ChevronLeft /> {t("back")}
            </Button>
          </div>
        )}
        {children}
      </main>

      <div className="mobile-toolbar-part">
        <MobileToolbar />
      </div>
    </div>
  );
};

export default MainLayout;
